import { useNavigate } from "react-router-dom";
import Header from "../components/Header"
import { useCurrencyMetadata } from '../hooks/queries/useCurrencyMetadata';

const FaqPage = () => {
  const navigate = useNavigate();
  const { data, updatedAtText, isPending, isError, refetch } = useCurrencyMetadata();
  return (
    <div className="container mx-auto px-4 pt-16 pb-8">
      <Header title="FAQ" showBackButton onBackClick={() => navigate(-1)} />
      
      <div className="mt-5 space-y-5">
        {/* 첫 번째 질문 */}
        <div>
          <h3 className="text-lg font-bold mb-2 text-gray-900">
            공금을 걷었어요! 어떻게 해야 하나요?
          </h3>
          <ul className="space-y-1 text-gray-600 text-[15px]">
            <li>• 여행 시작 전 공금 걷은 사람(총무)에게 '송금'을 기록하세요.</li>
            <li>• 이후 공금이 사용될 때마다 총무의 이름으로 '지출'을 기록하세요.</li>
          </ul>
        </div>

        {/* 두 번째 질문 */}
        <div>
          <h3 className="text-lg font-bold mb-2 text-gray-900">
            왜 이런 정산 결과가 나왔나요?
          </h3>
          <ul className="space-y-1 text-gray-600 text-[15px]">
            <li>• 그룹에 총무가 있는 경우와 아닌 경우가 달라요.</li>
            <li>• 총무가 설정된 경우에는 모든 사람이 총무를 통해서 송금을 주고받고 정산을 완료해요.</li>
            <li>• 총무가 없는 그룹은 멤버들끼리 서로 송금을 주고받는데, 송금과정이 단순화될 수 있어요.</li>
            <li>• 예시: A → B, B → C로 각각 송금해야 하는 경우, A → C로 직접 송금</li>
          </ul>
        </div>

        {/* 세 번째 질문 */}
        <div>
          <h3 className="text-lg font-bold mb-2 text-gray-900">
            방에 이상한 사람이 들어온 것 같아요!
          </h3>
          <ul className="space-y-1 text-gray-600 text-[15px]">
            <li>• 링크와 비밀번호가 모두 유출되면 모르는 사람이 들어올 수 있으니 항상 조심해야 해요.</li>
            <li>• 남은 정산을 빠르게 마치고 새로운 방을 만들어 사용하세요!</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-2 text-gray-900">
            환율은 언제 기준인가요?
          </h3>
          <ul className="space-y-1 text-gray-600 text-[15px]">
            <li>• {data?.source ?? 'exchangeratesapi.io'}가 전 세계 은행과 금융 데이터 제공업체의 시장 환율을 종합한 데이터를 사용해요.</li>
            <li>• 일반적으로 매수·매도 가격의 중간값을 기준으로 하며, 은행의 실제 환전·송금 환율과는 차이가 있을 수 있어요.</li>
            <li aria-live="polite">
              • 최근 업데이트: {isPending ? '확인 중이에요.' : isError ? '업데이트 정보를 불러오지 못했어요.' : updatedAtText ?? '업데이트 정보가 아직 없어요.'}
              {isError && (
                <button type="button" className="ml-2 underline" onClick={() => refetch()}>
                  다시 시도
                </button>
              )}
            </li>
          </ul>
          <a className="inline-block mt-2 text-gray-600 text-[15px] underline" href="https://exchangeratesapi.io/faq/" target="_blank" rel="noreferrer">
            환율 원출처 안내
          </a>
        </div>

        {/* Tip 섹션 */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="text-lg font-bold mb-2 text-gray-900">
            Tip. 사람이 많을수록 좋아요.
          </h3>
          <p className="text-gray-600 text-[15px]">
            N빵은 더 많은 사람들이 다양하게 참여했을 때 더 큰 힘을 발휘해요!
          </p>
        </div>
      </div>
    </div>
  )
}

export default FaqPage
